exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".recommend-resume-dialog .content-confirm{background-color:#2481ff;color:#fff;margin:0 20px 20px}.recommend-resume-dialog .content-confirm>h1{font-size:18px;padding:15px}.recommend-resume-dialog .content-confirm>.el-row{background-color:#59a0ff;padding:15px;border-radius:0 0 5px 5px}.recommend-resume-dialog .content-confirm-multiple{margin:0 0 20px 100px}.recommend-resume-dialog .content-confirm-multiple span{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31b91de1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/operation/managerEditDialog.vue
// module id = 906
// module chunks = 23